var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pickBy } from './utils/utils';
import { wixStylesFontUtils } from './utils/wixStyleFontUtils';
import { wixStylesColorUtils } from './utils/wixStylesColorUtils';
import { IS_RTL_PARAM } from './constants';
export function generateTPAParams(siteColors, siteTextPresets, styleParams, options) {
    var _a;
    var colorStyles = styleParams.colors;
    var fontStyles = pickBy(styleParams.fonts, wixStylesFontUtils.isValidFontParam);
    var numbers = styleParams.numbers || {};
    var colors = wixStylesColorUtils.getFullColorStyles({ colorStyles: colorStyles, siteColors: siteColors }) || {};
    var fonts = wixStylesFontUtils.getFullFontStyles({ fontStyles: fontStyles, siteTextPresets: siteTextPresets }) || {};
    var strings = pickBy(styleParams.fonts, wixStylesFontUtils.isStringHack);
    var booleans = __assign({}, styleParams.booleans, (_a = {}, _a[IS_RTL_PARAM] = options.isRTL, _a));
    return { colors: colors, fonts: fonts, numbers: numbers, strings: strings, booleans: booleans };
}
